import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CreditMemoDataBuilder } from './credit-memo-data.builder';
import { CreditMemoDataService } from './credit-memo-data.service';
import { EffectsModule } from '@ngrx/effects';
import { CreditMemoDataEffects } from './credit-memo-data.effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './credit-memo-data.reducer';
import { CreditMemoDataDispatcher } from './credit-memo-data.dispatcher';
import { CreditMemoDataStore } from './credit-memo-data.store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([CreditMemoDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class CreditMemoDataModule {
  static forRoot(): ModuleWithProviders<CreditMemoDataModule> {
    return {
      ngModule: CreditMemoDataModule,
      providers: [
        CreditMemoDataBuilder,
        CreditMemoDataDispatcher,
        CreditMemoDataService,
        CreditMemoDataStore,
      ],
    };
  }
}
